import { render, staticRenderFns } from "./CorreoConfig.vue?vue&type=template&id=241239a3&scoped=true"
import script from "./CorreoConfig.vue?vue&type=script&lang=js"
export * from "./CorreoConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241239a3",
  null
  
)

export default component.exports